export const HERO_IMAGE = "/hero-headshot.png";

export const ARTIST_PORTRAIT = "/about-portrait.png";

export const ARTWORKS = [
  {
    id: "art-07",
    title: "Sailfishing off West Palm Beach, FL",
    category: "Fun",
    url: "/fun-offshore.webp",
    aspect: "aspect-[4/5]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-08",
    title: "Fun with locals, Mainland China",
    category: "Fun",
    url: "/fun-china.jpg",
    aspect: "aspect-[4/5]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-09",
    title: "Cobia, Gulf of America",
    category: "Fun",
    url: "/fun-catch.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-10",
    title: "Family horseback riding, Big Sky Montana",
    category: "Fun",
    url: "/fun-bigsky.webp",
    aspect: "aspect-[4/3] lg:aspect-[16/10]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
  },
  {
    id: "art-11",
    title: "Love of my life, wife Sherry, Victoria Falls, Zimbabwe",
    category: "Fun",
    url: "/fun-vicfalls.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-12",
    title: "Montana tubing with Grandkids",
    category: "Fun",
    url: "/fun-tubing.jpg",
    aspect: "aspect-square",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-13",
    title: "Skiing at Whitefish Mountain Resort Montana",
    category: "Fun",
    url: "/fun-skiing.webp",
    aspect: "aspect-[4/5]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-14",
    title: "Hiking in Glacier",
    category: "Fun",
    url: "/fun-glacier.jpg",
    aspect: "aspect-[4/3] lg:aspect-[16/10]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
  },
  {
    id: "art-15",
    title: "Cruising in the Bahamas with wife Sherry",
    category: "Fun",
    url: "/fun-bahamas.jpg",
    aspect: "aspect-[4/3] lg:aspect-[16/10]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
  },
  {
    id: "art-16",
    title: "Gulfstream Sailfish",
    category: "Fun",
    url: "/fun-sailfish.webp",
    aspect: "aspect-[4/3] lg:aspect-[16/10]",
    span: "col-span-12",
    year: "",
    meta: "",
  },
  {
    id: "art-17",
    title: "Colorado Skiing with Family",
    category: "Fun",
    url: "/fun-purgatory.webp",
    aspect: "aspect-[5/4]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
  },
  {
    id: "art-18",
    title: "Big Tarpon to Win Tournament",
    category: "Fun",
    url: "/fun-tarpon.webp",
    aspect: "aspect-[4/3] lg:aspect-[16/10]",
    span: "col-span-12",
    year: "",
    meta: "",
  },
  {
    id: "art-19",
    title: "Zambia Photography",
    category: "Fun",
    url: "/fun-zambia.webp",
    aspect: "aspect-[6/5]",
    span: "col-span-12",
    year: "",
    meta: "",
  },
  {
    id: "art-20",
    title: "Inspecting finished solar panels, China",
    category: "Engineering/Manufacturing",
    url: "/eng-solar.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-21",
    title: "Acid conversion process, Cali, Colombia",
    category: "Engineering/Manufacturing",
    url: "/eng-acid.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-22",
    title: "Certifying chemical plant, Dar es Salaam, Tanzania",
    category: "Engineering/Manufacturing",
    url: "/eng-tanzania.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-23",
    title: "Financial compliance, Dubai, UAE",
    category: "Engineering/Manufacturing",
    url: "/eng-dubai.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-24",
    title: "Factory Quality Inspection, Shenzhen, China",
    category: "Engineering/Manufacturing",
    url: "/eng-shenzhen.webp",
    aspect: "aspect-[4/5]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-25",
    title: "Inspecting Ground Screw shipment, Dongguan, China",
    category: "Engineering/Manufacturing",
    url: "/eng-groundscrew.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-26",
    title: "Chemistry experiment, Florida",
    category: "Engineering/Manufacturing",
    url: "/eng-chemistry.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
  },
  {
    id: "art-27",
    title: "Trade Show Marketing",
    category: "Engineering/Manufacturing",
    url: "/eng-tradeshow.webp",
    aspect: "aspect-[5/4]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
  },
  {
    id: "art-28",
    title: "Working hard on sourcing trip, China",
    category: "Engineering/Manufacturing",
    url: "/eng-sourcing.jpg",
    aspect: "aspect-[5/4]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
  },
  {
    id: "art-29",
    title: "Young Leopard, Zambia",
    category: "Photography",
    url: "/photo-leopard.webp",
    aspect: "aspect-[4/3] lg:aspect-[16/10]",
    span: "col-span-12",
    year: "",
    meta: "",
  },
  {
    id: "art-30",
    title: "Night dive, Grand Turk, Turks and Caicos",
    category: "Photography",
    url: "/photo-shrimp.jpg",
    aspect: "aspect-[1252/980]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-31",
    title: "Elephant Battle, Zambia",
    category: "Photography",
    url: "/photo-elephants.webp",
    aspect: "aspect-[3/2]",
    span: "col-span-12",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-32",
    title: "3 Zebras all in a row",
    category: "Photography",
    url: "/photo-zebras.webp",
    aspect: "aspect-[3/2]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-33",
    title: "Edge of the Drop Off, Bonaire",
    category: "Photography",
    url: "/photo-bonaire.jpg",
    aspect: "aspect-[928/576]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-34",
    title: "Wife, Sherry with Arrow crab close-up view!",
    category: "Photography",
    url: "/photo-arrowcrab.jpg",
    aspect: "aspect-[3/2]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-35",
    title: "Interviewing with the Press, Oceanside, California",
    category: "Engineering/Manufacturing",
    url: "/eng-press.jpg",
    aspect: "aspect-[16/9]",
    span: "col-span-12",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-36",
    title: "Oxpeckers on Kudu, Zambia",
    category: "Photography",
    url: "/photo-kudu.webp",
    aspect: "aspect-[3/2]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-37",
    title: "Lion after big meal, Zambia",
    category: "Photography",
    url: "/photo-lion.webp",
    aspect: "aspect-[3/2]",
    span: "col-span-12",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-38",
    title: "Flamingo Tongue, Belize",
    category: "Photography",
    url: "/photo-flamingo.jpg",
    aspect: "aspect-[1532/984]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-39",
    title: "Forming Co-op with Asimino Indigenous people group, Frontier Colombia",
    category: "Gold",
    url: "/gold-coop.webp",
    aspect: "aspect-[4/3]",
    span: "col-span-12",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-40",
    title: "Gold Bars for export, Bogota, Colombia",
    category: "Gold",
    url: "/gold-bars.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-41",
    title: "Gold mine in Medellin, Colombia",
    category: "Gold",
    url: "/gold-mine.webp",
    aspect: "aspect-[4/3]",
    span: "col-span-12 lg:col-span-7",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-42",
    title: "With Asimino's",
    category: "Gold",
    url: "/gold-asimino.jpg",
    aspect: "aspect-[4/3]",
    span: "col-span-12",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-43",
    title: "Blasting Dynamite at Mine, Colombia",
    category: "Gold",
    url: "/gold-dynamite.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-44",
    title: "No roads in... only helicopter",
    category: "Gold",
    url: "/gold-heli.webp",
    aspect: "aspect-square",
    span: "col-span-12",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-45",
    title: "Gold Mine Security",
    category: "Gold",
    url: "/gold-security.jpg",
    aspect: "aspect-[4/5]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-46",
    title: "Final Gold Bars",
    category: "Gold",
    url: "/gold-final.webp",
    aspect: "aspect-[2/3]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-47",
    title: "Donating Sluice Boxes to Community",
    category: "Gold",
    url: "/gold-sluice.webp",
    aspect: "aspect-[1165/1026]",
    span: "col-span-12",
    year: "",
    meta: "",
    loose: true,
  },
  {
    id: "art-48",
    title: "Hermanos",
    category: "Gold",
    url: "/gold-hermanos.webp",
    aspect: "aspect-[3/4]",
    span: "col-span-12 lg:col-span-5",
    year: "",
    meta: "",
    loose: true,
  },

];

export const PROJECTS = [
  { year: "2026", title: "Veils", venue: "Independent Project — Los Angeles" },
  { year: "2025", title: "Monoliths", venue: "Collaboration — Copenhagen" },
  { year: "2024", title: "Night Passages", venue: "Independent Project — New York" },
  { year: "2023", title: "First Light", venue: "Early Work — Lisbon" },
];
